<template>
  <div class="page-awards">
    <title-bar title="我的证书"></title-bar>
    <div class="list-wrap">
      <awards-item @preview="previewPDF" v-for="item in certList" :key="item.id" :data="item"></awards-item>
    </div>

    <div v-if="total == 0" class="empty-box">
      <img src="https://www.yulin365.net/attachment/mini-icon/nocert.png" class="img" />
    </div>
    <div class="pagination-box">
      <el-pagination
        :hide-on-single-page="true"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!--  -->
    <el-dialog :destroy-on-close="true" v-loading="loading" title="" :visible.sync="dialogVisible" width="70%" :before-close="handleClose">
      <div class="content-wrap">
        <pdf @page-loaded="pageLoaded" class="pdf-view" :src="previewUrl"></pdf>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import TitleBar from "@/views/pages/personal-center/component/TitleBar";
  import AwardsItem from "@/views/pages/personal-center/component/AwardsItem";
  import pdf from "vue-pdf";
import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory'

  export default {
    name: "awards",
    data() {
      return {
        list: [],
        total: 10,
        currentPage: 1,
        pageSize: 10,
        certList: [],
        dialogVisible: false,
        previewUrl: "",
        loading: false,
      };
    },
    components: {
      TitleBar,
      AwardsItem,
      pdf,
    },
    computed: {
      pdfUrl() {
        let src = pdf.createLoadingTask({
          url: this.test_pdf,
          cMapUrl: "../../../../assets/cmaps/",
          cMapPacked: true,
        });
        return src;
      },
    },
    created() {
      // this.setMock();
      this.getCertList();
    },
    mounted() {},
    methods: {
      setMock() {
        let data = {
          list: [
            {
              id: "350000201104055219",
              name: "顾洋",
              img: "http://dummyimage.com/200x200/4A7BF7&text=Hello",
              label: "按长",
              title: "认那实西明得划来按五打效音写求和度下红党元实解是部运西一深",
              date: "2009-12-20",
              activity_name: "石边定形学程量很真提入心目老构器我子色为。",
            },
            {
              id: "820000201909099748",
              name: "龚芳",
              img: "http://dummyimage.com/200x200/4A7BF7&text=Hello",
              label: "没度",
              title: "基知种布划革两属个严提应更高声她连条写知走",
              date: "1983-05-23",
              activity_name: "指张县织手小因动参如比习写手证置指电着方。",
            },
            {
              id: "350000199305249837",
              name: "尹平",
              img: "http://dummyimage.com/200x200/4A7BF7&text=Hello",
              label: "身改",
              title: "据无度度争矿该重同空较路求毛想导很象许术支风产整养政开",
              date: "1996-09-02",
              activity_name: "算素打还华见须民装需总直划院提五格究专且。",
            },
            {
              id: "51000019951013019X",
              name: "田杰",
              img: "http://dummyimage.com/200x200/4A7BF7&text=Hello",
              label: "之布",
              title: "马认利量长三什音整用真维却先定阶状识专生三第话学养传龙种话求七器",
              date: "1979-03-29",
              activity_name: "政七习基温需都些联么要受就利记万着严一个。",
            },
            {
              id: "320000199003317085",
              name: "徐丽",
              img: "http://dummyimage.com/200x200/4A7BF7&text=Hello",
              label: "队心气表",
              title: "书需们色听济离中过成马即过内将空土界须整响",
              date: "1986-04-19",
              activity_name: "区感到好特利步周音层段成离列展特资接又与。",
            },
            {
              id: "440000198305305162",
              name: "毛军",
              img: "http://dummyimage.com/200x200/4A7BF7&text=Hello",
              label: "太安北构",
              title: "状变至或性更能外见例取车期自动际因指第王",
              date: "1980-11-26",
              activity_name: "物世型持形着活主情志走照商记精处清定至元。",
            },
            {
              id: "130000198704206222",
              name: "蒋磊",
              img: "http://dummyimage.com/200x200/4A7BF7&text=Hello",
              label: "革知",
              title: "们置步查加如农处入拉连市",
              date: "2008-11-29",
              activity_name: "应里关水入关非志计作气见例中音事子利精共。",
            },
            {
              id: "360000198305091395",
              name: "邱敏",
              img: "http://dummyimage.com/200x200/4A7BF7&text=Hello",
              label: "际响算政",
              title: "各群料支达只细斗别都才论民达越代调争还法面只从素图半历界六下标重高",
              date: "1993-02-18",
              activity_name: "须支成反算月增极复前法决所有办备统法广成。",
            },
            {
              id: "63000020170620846X",
              name: "段霞",
              img: "http://dummyimage.com/200x200/4A7BF7&text=Hello",
              label: "说长想",
              title: "育来她必属日物律际生",
              date: "1992-01-26",
              activity_name: "复知体写农易起酸行正已离转局装便之条加候。",
            },
            {
              id: "510000199011222057",
              name: "胡洋",
              img: "http://dummyimage.com/200x200/4A7BF7&text=Hello",
              label: "重北交",
              title: "持究放片回最列线离置便分装列其为更通化相东日团县程或",
              date: "2021-04-08",
              activity_name: "选示级向利习时无至五方商思感称农社常保劳。",
            },
          ],
        };

        this.list = data.list;
      },
      handleSizeChange() {},
      handleCurrentChange(page) {
        this.currentPage = page;
        this.getCertList(page);
      },
      getCertList(page = 1) {
        this.$api
          .fetchUserCert({
            params: {
              page: page,
              "per-page": this.pageSize,
            },
          })
          .then(res => {
            console.log("success", res);
            this.certList = res.data.cert_list;
            this.total = res.data.total_num;
            this.$nextTick(() => {
              window.scrollTo({
                top: 0,
              });
            });
          })
          .catch(err => {
            console.log("error", err);
          });
      },
      previewPDF(url) {
        //
        console.log("url", url);
        this.dialogVisible = true;
        let src = pdf.createLoadingTask({
          url: url,
          // CMapReaderFactory
          cMapUrl: "/cmaps/",
          cMapPacked: true,
        });
        this.loading = true
        this.previewUrl = src;
      },
      handleClose() {
        //
        this.dialogVisible = false;
        this.previewUrl = "";
        this.loading = true;
      },
      downloadFile(url) {
        return new Promise((resolve, reject) => {
          this.$api
            .fetchArrayBuffer({
              url: url,
            })
            .then(res => {
              //
              let blob = new Blob([res], {
                // type: "application/octet-stram",
                // "content-disposition": "attachment",
                type: "application/pdf",
              });
              //  type: "application/pdf;charset=UTF-8",
              let link = window.URL.createObjectURL(blob);
              this.previewUrl = link;
              console.log("bb", link);
              // let a = document.createElement("a");
              // a.href = link;
              // a.download = "证书.pdf";
              // document.body.appendChild(a);
              // a.click();
              // document.body.removeChild(a);
              // window.URL.revokeObjectURL(link);
            })
            .catch(err => {
              //
            });
        });
      },
      pageLoaded(e) {
        //
        this.loading = false;
        console.log("payload", e);
      },
      numPages(e){
        console.log('e',e)
      }
    },
  };
</script>

<style scoped lang="scss">
  .page-awards {
    padding: 30px 30px 0;
    .pagination-box {
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .empty-box {
      display: flex;
      align-items: center;
      justify-content: center;
      .img {
        width: 350px;
        height: 350px;
        object-fit: contain;
      }
    }
  }
  .view-pdf {
    width: 800px;
    height: 500px;
  }
  .content-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    .pdf-view {
      width: 800px;
      height: 500px;
    }
  }
</style>
